/** 自动确认提货剩余时间 */
export const autoConfirmRemaininTime = (time: string) => {
    // 开始时间
    const startTime = new Date(time).getTime();
    const endTime = startTime + 48 * 60 * 60 * 1000;
    const now = Date.now();
    // 计算剩余时间（毫秒）
    const timeDiff = endTime - now;

    // 如果剩余时间小于等于0，则已过期
    if (!time || timeDiff <= 0) {
        return {
            formattedTime: "00:00:00",
            isExpired: true
        };
    }

    // 计算小时、分钟、秒
    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    // 格式化为 HH:mm:ss
    const formattedTime = [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        seconds.toString().padStart(2, "0")
    ].join(":");

    return {
        formattedTime,
        isExpired: false
    };
};

/** 是否显示剩余时间 */
export const showRestTime = (time: string) => {
    if (!time) return false;
    const endTime = new Date(time).getTime() + 48 * 60 * 60 * 1000;
    const now = Date.now();
    // 做1s的缓冲，避免倒计时结束的瞬间消失，无法触发刷新页面
    return !!(endTime - now > -1000);
};
